/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdSegmentedProps } from './type';
const props: TdSegmentedProps = {
  /** 是否撑满父元素宽度 */
  block: {
    type: Boolean,
    value: false,
  },
  /** 是否禁用 */
  disabled: {
    type: Boolean,
  },
  /** 数据化配置选项内容 */
  options: {
    type: Object,
    value: [],
  },
  /** 当前选中的值 */
  value: {
    type: null,
    value: null,
  },
  /** 当前选中的值，非受控属性 */
  defaultValue: {
    type: null,
  },
};

export default props;
